exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._6r8KkhLwSmuzZJTLbtZfd{border-top:1px solid #e0e0e0}._6r8KkhLwSmuzZJTLbtZfd ._2BBb8747kpEZk1bNf0IuyJ{height:40px;display:flex;justify-content:space-between;align-items:center;cursor:default}._6r8KkhLwSmuzZJTLbtZfd ._2BBb8747kpEZk1bNf0IuyJ h3{margin:0 0}._6r8KkhLwSmuzZJTLbtZfd:last-child{border-bottom:1px solid #e0e0e0}._6r8KkhLwSmuzZJTLbtZfd .a9f5uPUBcqmeRYLbaK9qm{color:#757575;cursor:pointer;transform:rotate(0deg);transition:transform 200ms ease}._6r8KkhLwSmuzZJTLbtZfd .a9f5uPUBcqmeRYLbaK9qm._15V9iLPWQPOgNKmZyLbMTF{transform:rotate(180deg)}._6r8KkhLwSmuzZJTLbtZfd ._2Yi30Sk4Kz9mP9JAvg6m2q{padding:10px 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"AccordionItem": "_6r8KkhLwSmuzZJTLbtZfd",
	"titleBar": "_2BBb8747kpEZk1bNf0IuyJ",
	"expandIcon": "a9f5uPUBcqmeRYLbaK9qm",
	"expanded": "_15V9iLPWQPOgNKmZyLbMTF",
	"content": "_2Yi30Sk4Kz9mP9JAvg6m2q"
};